import { AvailabilityEnum } from '../../../products/ProductTypes';
import { OrderCalculationHeaders, PriceCompositionTotals, Section } from '../orderProducts.types';

export interface GetHeaderTotalsProps {
  headers?: OrderCalculationHeaders;
  headerId?: string | null;
  sectionAvailability?: AvailabilityEnum;
  sectionWithPendencies: boolean;
  productCode?: string;
  groupIdentifier?: string;
}

export interface SectionTotals {
  itemsQuantity: number;
  piecesQuantity: number;
  total: number;
  priceCompositionTotals: PriceCompositionTotals[];
}

export interface ParentGroupSections {
  sections: Section[];
  isExpanded: boolean;
}

export interface GetParentGroupSectionsParams {
  sections: Section[];
  parentGroupKey: string;
  collapsedParentGroupKeys: string[];
}

export enum ParentGroupHeaderPlacement {
  NONE = 'none',
  INLINE = 'inline',
  STICKY_SLOT = 'stickySlot',
}

export interface ResolveParentGroupHeaderPlacementParams {
  section?: Section;
  parentGroupSections: Section[];
  hasStickyParentGroupSlot: boolean;
  isParentGroupExpanded: boolean;
}
